import React from 'react';
import './Services.css';
import Image1 from '../../assets/service-1.svg'
import Image2 from '../../assets/service-2.svg'
import Image3 from '../../assets/service-3.svg'

const data = [
    {
        id: 1,
        image: Image1,
        title: "Full-Stack Development",
        description:
            "Building fast, mobile-first web platforms from scratch using React, Python, and modern CSS frameworks, optimized for smooth performance on any device.",
    },
    {
        id: 2,
        image: Image2,
        title: "AI & Workflow Automation",
        description:
            "Integrating LLMs (Llama 3, LangChain) and custom automation tools to streamline complex messaging, data processing, and background workflows.",
    },
    {
        id: 3,
        image: Image3,
        title: "Backend & System Reliability",
        description:
            "Designing scalable REST APIs, PostgreSQL databases, and real-time architectures (WebSockets, WebRTC), paired with ongoing technical support for zero downtime.",
    },
];

const Services = () => {
    return (
        <section className="services container section" id="services">
            <h2 className="section__title">Services</h2>

            <div className="services__container grid">
                {data.map(({ id, image, title, description }) => {
                    return (
                        <div className="services__card" key={id}>
                            <img src={image} alt='' className='services__img' width="80" />

                            <h3 className="services__title">{title}</h3>
                            <p className="services__description">{description}</p>
                        </div>
                    )
                })}
            </div>
        </section>
    )
}

export default Services